/**
 * @desc: Copied from https://git.perkbox.io/backend-services/login/blob/master/internal/errorLib/codes.go
 */
enum LoginCodes {
  RequestUrlParamMissing = "PBLOGRequestUrlParamMissing",
  RequestBodyInvalid = "PBLOGRequestBodyInvalid",

  PreconditionFailedErr = "PBLOGPreconditionFailed",

  PasswordMissing = "PBLOGPasswordMissing",
  UserDisabled = "PBLOGUserDisabled",
  UnexpectedLoginChallenge = "PBLOGUnexpectedLoginChallenge",
  LoginChallengeNewPasswordRequired = "PBLOGLoginChallengeNewPasswordRequired",
  InvalidLoginDetails = "PBLOGInvalidLoginDetails",

  RespondToChallengeUnknown = "PBLOGRespondToChallengeUnknown",
  RespondToChallengeInvalid = "PBLOGRespondToChallengeInvalid",
  RespondToChallengeFailed = "PBLOGRespondToChallengeFailed",

  UserNotFound = "PBLOGUserNotFound",
  PasswordCriteriaFailed = "PBLOGPasswordCriteriaFailed",
  PasswordTooWeak = "PBLOGPasswordTooWeak",
  UserNotConfirmed = "PBLOGUserNotConfirmed",
  LimitExceeded = "PBLOGLimitExceeded",
  InvalidConfirmationCode = "PBLOGInvalidConfirmationCode",
  ExpiredConfirmationCode = "PBLOGExpiredConfirmationCode",

  ForgotPasswordSamlUser = "PBLOGForgotPasswordSamlUser",

  PBLOGGlobalTenantNotFound = "PBLOGGlobalTenantNotFound",
  OTACExpired = "PBAUTHOTACExpired",
  InvalidOTAC = "PBAUTHInvalidOTAC",
  OTACAlreadyUsed = "PBAUTHOTACAlreadyUsed"
}

export default LoginCodes
